module.exports = __webpack_public_path__ + "static/media/zgjs.b311fd9b.mp4";